// these values are following BE StaffInvitationAccessType
export enum AccessTypeModel {
  NoAccess = 0,
  FullAccess = 1,
  Trainer = 2,
  Restricted = 3,
}
